import { Spin } from 'antd';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useGlobal } from 'reactn';
import TopBackgroundUrl from '../../assets/MCWA_Dashboard_HeroImage.jpg';
import ConsumptionBackgroundUrl from '../../assets/water-droplets-bg.jpg';
import ContactUs from '../../common/footer/ContactUs';
import FAQs from '../../common/footer/FAQs';
import WaterFacts from '../../common/footer/WaterFacts';
import Section from '../../common/section/Section';
import SvcAccountHeader from '../svcAccountHeader/SvcAccountHeader';
import AccountSummary from './AccountSummary';
import Consumption from './Consumption';
import CustomerService from './CustomerService';
import GoPaperless from './GoPaperless';
import MeterRead from './MeterRead';
import Moving from './Moving';
import PastPayments from './PastPayments';
import QuickTips from './QuickTips';
import UpcomingPayment from './UpcomingPayment';
import UsageAtGlance from './UsageAtGlance';

const Dashboard = () => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (serviceAccounts?.length === 0) {
    return <Redirect to="/user/find-property" />;
  }

  // lets make sure that all required data is present before dashboard screen renders
  if (
    !selectedServiceAccount?.billingHistory ||
    !selectedServiceAccount?.consumptionData ||
    !selectedServiceAccount?.eBillStatus ||
    !selectedServiceAccount?.meterData ||
    !selectedServiceAccount?.pastPaymentData ||
    !selectedServiceAccount?.summaryData
  ) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <Spin tip="Loading account information. Please stand by." />
      </div>
    );
  }

  // if meterData is an array, it means the account is fire service related and does not need provide meter readings
  const showMeterRead =
    !selectedServiceAccount?.meterData?.data?.is_radio_meter &&
    selectedServiceAccount?.meterData?.status?.code === 0;

  return (
    <div className="dashboard">
      <section className="main">
        <SvcAccountHeader />
        <Section
          title="My Bills and Payments"
          backgroundImageUrl={TopBackgroundUrl}
          // whiteText
        >
          <div className="flex flex-wrap">
            <UpcomingPayment className="w-full lg:w-1/3" />
            <AccountSummary className="w-full lg:w-1/3" />
            <div className="w-full lg:w-1/3">
              <PastPayments />
              <GoPaperless />
            </div>
          </div>
        </Section>
        <Section title="Service Requests">
          <div className="flex flex-wrap">
            {showMeterRead && <MeterRead />}
            <Moving className="w-full lg:w-1/3" serviceRequestColor />
            <QuickTips className="w-full lg:w-1/3" />
          </div>
        </Section>
        <Section
          title="Water Consumption"
          whiteText
          backgroundImageUrl={ConsumptionBackgroundUrl}
          // whiteText
        >
          <div className="flex flex-wrap">
            <Consumption className="w-full lg:w-2/3" />
            <div className="w-full lg:w-1/3">
              <UsageAtGlance />
            </div>
          </div>
        </Section>
        <Section title="Customer Service">
          <CustomerService />
        </Section>
        <Section>
          <div className="flex flex-wrap justify-center">
            <ContactUs className="w-full lg:w-1/3" />
            <FAQs className="w-full lg:w-1/3" />
            <WaterFacts className="w-full lg:w-1/3" />
          </div>
        </Section>
      </section>
    </div>
  );
};

export default Dashboard;
